import { message } from "antd";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { getParticipantesEntregas } from "../../../../services/financiero/participantesEntregasService";

export const exportarParticipantesEntregasExcel = async () => {
  try {
    const res = await getParticipantesEntregas();
    const datos = res || [];

    if (!datos.length) {
      message.warning("No hay datos para exportar");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Participantes Entregas");

    // 🔥 COLUMNAS
    worksheet.columns = [
      { header: "Proyecto", key: "proyecto" },
      { header: "Código", key: "codigo" },
      { header: "Participante", key: "nombre_participante" },
      { header: "Identificación", key: "numero_identificacion" },
      { header: "Departamento", key: "departamento" },
      { header: "Municipio", key: "municipio" },
      { header: "Producto", key: "nombre_producto" },
      { header: "PO", key: "Numero_PO" },
      { header: "Cantidad Entregada", key: "cantidad_entregada" },
      { header: "Valor Total", key: "valor_total_entregado" },
      { header: "Estado", key: "estado_entrega" }
    ];

    // 🎨 HEADER
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4472C4" }
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // 📊 DATA
    datos.forEach(row => {
      worksheet.addRow({
        ...row,
        cantidad_entregada: Number(row.cantidad_entregada),
        valor_total_entregado: Number(row.valor_total_entregado)
      });
    });

    // 💰 FORMATO MONEDA
    worksheet.getColumn("valor_total_entregado").numFmt = '"$"#,##0';

    // 📐 AUTO AJUSTE
    worksheet.columns.forEach(col => {
      let maxLength = 10;
      col.eachCell({ includeEmpty: true }, cell => {
        const val = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, val.length);
      });
      col.width = maxLength + 2;
    });

    // 🧊 congelar encabezado
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // 📥 DESCARGA
    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
      new Blob([buffer]),
      `Participantes_Entregas_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
    );

  } catch (error) {
    console.error(error);
    message.error("Error generando exportable");
  }
};